import { render, staticRenderFns } from "./productConfigResend.vue?vue&type=template&id=34c88334&"
import script from "./productConfigResend.vue?vue&type=script&lang=js&"
export * from "./productConfigResend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports